<div class="date-wrap" [ngClass]="{'isPC': isPC,'isCamp':isCamp}">
  <div class="date-lock">
    <span *ngIf="courseOverdue">
      已过期
    </span>
    <span *ngIf="!courseOverdue">
      {{ openTime }}开放
    </span>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/component-ui/date-states/component.dateStates.html